import api from './api';

export const emailTemplateService = {
  getEmailTemplates: async (projectId) => {
    const response = await api.get('/emailtemplates', { params: { project: projectId } });
    return response.data;
  },

  getEmailTemplate: async (id) => {
    const response = await api.get(`/emailtemplates/${id}`);
    return response.data;
  },

  createEmailTemplate: async (data) => {
    const response = await api.post('/emailtemplates', data);
    return response.data;
  },

  updateEmailTemplate: async (id, data) => {
    const response = await api.put(`/emailtemplates/${id}`, data);
    return response.data;
  },

  deleteEmailTemplate: async (id) => {
    const response = await api.delete(`/emailtemplates/${id}`);
    return response.data;
  }
};
